// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectRooms_root__3JeAC"};